{
  "title": "Deposits",
  "list": {
    "title": "Deposit list",
    "search_placeholder": "Search by deposit reference",
    "header": {
      "ticket_code_name": "Internal code / Name of the event",
      "deposit_reference": "Deposit reference",
      "ticket_operation": "Operation type",
      "submission_url": "Submission url",
      "remaining_days": "Delays",
      "remaining_days_tooltip": "If the regime is in declaration : working days otherwise calendar days",
      "ticket_start_at": "Start date",
      "ticket_end_at": "End date",
      "submission_regime": "Regime",
      "workflow_step": "Workflow step",
      "deposit_consignee": "Consignee",
      "deposit_status": "Deposit status"
    }
  },
  "filter": {
    "ticket_name": "Ticket name",
    "ticket_code": "Internal code",
    "ticket_event_type": "Event type",
    "ticket_operation_name": "Operation",
    "ticket_initiator_id": "Initiator",
    "event_date_range": "Start and end date",
    "ticket_submission_regime": "Submission regime",
    "ticket_workflow_step_or_status": "Workflow step",
    "status": "Deposit status"
  },
  "day_type": {
    "WORKING": "Working days",
    "BUSINESS": "Business days",
    "CALENDAR": "Calendar days"
  }
}
